import { Progress } from '@ui';
import { cx } from 'class-variance-authority';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Voucher } from '../types';

interface Props {
    voucher: Voucher;
}

const VoucherStatus = ({ voucher }: Props) => {
    const { t } = useTranslation('voucher');
    const progress =
        voucher.type === 'discount'
            ? voucher.voucherables_count / (voucher.usages ?? 1)
            : (voucher.value_used / voucher.value) * 100;

    return (
        <div
            className={cx(
                'tw-card-flat tw-overflow-hidden tw-border-0 tw-border-l-8 tw-border-solid tw-border-success tw-p-3 tw-text-xs',
                voucher.type === 'discount' && '!tw-border-yellow-400',
                voucher.type === 'card' && '!tw-border-blue-400',
                voucher.type === 'value' && '!tw-border-green-400',
                !voucher.is_active && '!tw-border-error'
            )}
        >
            <div className="tw-mb-3 tw-grid tw-grid-cols-2">
                <span className="tw-font-bold">{t('status.createdAt')}</span>
                <span>{moment(voucher.created_at).format('DD.MM.YYYY')}</span>
                <span className="tw-font-bold">{t('status.invoicedAt')}</span>
                <span>
                    {voucher.last_invoice_created_at
                        ? moment(voucher.last_invoice_created_at).format('DD.MM.YYYY')
                        : '-'}
                </span>
                <span className="tw-font-bold">{t('status.redemptions')}</span>
                <span>{voucher.voucherables_count}</span>
                <span className="tw-font-bold">{t('status.validUntil')}</span>
                <span>{moment(voucher.expires_at).format('DD.MM.YYYY')}</span>

                <div className="tw-col-span-2 tw-mb-2 tw-border-0 tw-border-b tw-border-solid tw-border-accents-4 tw-pb-2" />

                {voucher.type === 'discount' ? (
                    <>
                        <span className="tw-font-bold">{t('status.validFrom')}</span>
                        <span>{moment(voucher.valid_from).format('DD.MM.YYYY')}</span>
                        <span className="tw-font-bold">{t('status.maxRedemptions')}</span>
                        <span>{voucher.usages}</span>
                    </>
                ) : voucher.type === 'card' ? (
                    <>
                        <span className="tw-font-bold">{t('status.email')}</span>
                        <span>{voucher.user_email}</span>
                        <span className="tw-font-bold">{t('status.value')}</span>
                        <span>{t('status.unitsValue', { used: voucher.value_used, total: voucher.value })}</span>
                    </>
                ) : (
                    <>
                        <span className="tw-font-bold">{t('status.email')}</span>
                        <span>{voucher.user_email}</span>
                        <span className="tw-font-bold">{t('status.name')}</span>
                        <span>{voucher.user_name}</span>
                        <span className="tw-font-bold">{t('status.value')}</span>
                        <span>
                            {voucher.value_used.toFixed(2)} € / {voucher.value.toFixed(2)} €
                        </span>
                    </>
                )}
            </div>
            <Progress color={voucher.is_active ? 'success' : 'error'} size="sm" progress={progress / 100} />
        </div>
    );
};

export default VoucherStatus;
